export interface TenantFeatureDefinition {
  code: string;
  title: string;
  description: string;
  sortOrder: number;
  isActive: boolean;
}

export interface TenantFeature {
  code: string;
  title: string;
  description: string;
  sortOrder: number;
  isEnabled: boolean;
  isOverridden: boolean;
}

export const tenantFeatureCodes = {
  leads: 'LEADS',
  customers: 'CUSTOMERS',
  organizations: 'ORGANIZATIONS',
  products: 'PRODUCTS',
  pipelines: 'PIPELINES',
  sms: 'SMS',
  campaigns: 'CAMPAIGNS',
  personalLanding: 'PERSONAL_LANDING',
  customerInterest: 'CUSTOMER_INTEREST',
  productInteractionTracking: 'PRODUCT_INTERACTION_TRACKING',
  rfq: 'RFQ',
  quotation: 'QUOTATION',
  aiAssistant: 'AI_ASSISTANT',
  restaurantPos: 'RESTAURANT_POS',
} as const;

export type TenantFeatureCode = (typeof tenantFeatureCodes)[keyof typeof tenantFeatureCodes];
